<template>
  <div class="video-list">
    <div class="video-template" v-for="(data,index) in datas" :key="index" @click="goPlayer(data)">
      <div class="heart-power-img">
        <img :src="data.imgurl | filterB" />
      </div>
      <div class="public-text">
        <p>{{data.title}}</p>
        <p>{{data.source}}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: [],
      axio: {
        type: "",
        url: ""
      }
    };
  },
  methods: {
    getMsg() {
      if (this.axio.type == "get") {
        this.axios[this.axio.type](this.axio.url, {
          params: {
            title: this.$route.query.title
          }
        }).then(e => {
          switch (e.data.code) {
            case 0:
              this.datas = e.data.msg;
              break;
            default:
              break;
          }
        });
      }
    },
    goPlayer(value) {
      // console.log(value);
      if (value.newpath == "") {
        this.$router.push({
          path: "/iframeVedio",
          query: { title: "视频播放", iframeUrl: value.path }
        });
      } else {
        this.$router.push({
          path: "/themeedu/viedeoPlay",
          query: {
            title: "视频播放",
            newpath: value.newpath
          }
        });
      }
    }
  },
  mounted() {
    this.axio.url = this.$route.query.url;
    this.axio.type = this.$route.query.type;
    this.getMsg();
  },
  filters: {
    filterB: function(value) {
      if (value != undefined)
        return value.indexOf("http") > -1
          ? value
          : `http://qswgadmin.djplus.cn/Tittle/${value}`;
    }
  }
};
</script>
<style lang='scss' scoped>
.video-list {
  .video-template {
    .public-text {
      p {
        &:nth-child(1) {
          padding-top: 0.2rem;
          font-size: 0.28rem;
          color: #333333;
          line-height: 1.3;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
          margin-bottom: 0.3rem;
        }
        &:nth-child(2) {
          padding-top: 0.1rem;
          font-size: 0.24rem;
          color: #666666;
          line-height: 1.3;
        }
      }
    }
    .heart-power-img {
      img {
        background: #f5f5f5;
        width: 2.4rem;
        height: 1.8rem;
      }
      margin-right: 0.4rem;
    }
    display: flex;
    border-bottom: 0.01rem solid #dddddd;
    padding: 0.35rem 0;
    width: 94%;
    margin: 0 auto;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>